module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-bar-expand-be39ab08.svg";